// تقرير «الرواتب الموقوفة» المطبوع بنفس هوية تقرير الرواتب (ترويسة + بطاقات + جدول).
import { esc, today } from "./reportFormat";
import { brandLogo, brandName } from "./reportBrand";
import { HL } from "./holdsReportLabels";

const card = (label, value, tone = "") =>
  `<div class="card"><div class="label">${esc(label)}</div><div class="value ${tone}">${esc(value)}</div></div>`;

export const holdsHeader = (data, L, brand) => `<div class="header">
  ${brandLogo(brand)}
  ${brandName(brand)}
  <h1>${esc(L.title)}</h1>
  <h2>${esc(L.subtitle)}</h2>
  <p>${esc(L.generatedAt)}: ${today()}</p>
</div>`;

export const holdsCards = (data, L) => {
  const items = data.items || [];
  const days = items.reduce((sum, i) => sum + (i.absence_days || []).length, 0);
  return `<div class="cards">${[
    card(L.cards[0], items.length, items.length ? "negative" : "positive"),
    card(L.cards[1], days),
    card(L.cards[2], (data.branch_rules || []).length),
    card(L.cards[3], String(data.last_scan_at || "—").slice(0, 16).replace("T", " ")),
  ].join("")}</div>`;
};

export const holdsTable = (data, L) => {
  const head = L.cols.map((c) => `<th>${esc(c)}</th>`).join("");
  const items = data.items || [];
  const body = items.length
    ? items
        .map((i) => `<tr>
          <td><span class="b">${esc(i.employee_name || "—")}</span></td>
          <td>${esc(i.employee_email || "—")}</td>
          <td>${esc(i.branch_name || "—")}</td>
          <td class="danger b">${(i.absence_days || []).length}</td>
          <td class="sub neg">${esc((i.absence_days || []).join(", "))}</td>
          <td>${esc(String(i.held_at || "").slice(0, 10))}</td>
        </tr>`)
        .join("")
    : `<tr><td colspan="${L.cols.length}">${esc(L.empty)}</td></tr>`;
  return `<table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>`;
};

export const holdsRules = (data, L) => {
  const rules = (data.branch_rules || [])
    .map((r) => {
      const name = r.branch_name_ar && L === HL.ar ? r.branch_name_ar : r.branch_name;
      const hold = r.days > 0 ? L.ruleBranch.replace("{n}", r.days) : L.ruleDisabled;
      const deduct = r.deduct_absence === false
        ? L.ruleNoDeduction
        : L.ruleDeduction.replace("{n}", r.absence_per_day ?? 1);
      return `<div><span class="b">${esc(name)}:</span> ${esc(hold)} · ${esc(deduct)}</div>`;
    })
    .join("");
  return `<div class="explain"><div class="b">${esc(L.rulesTitle)}</div>${rules}
    <div>${esc(L.note1)}</div><div>${esc(L.note2)}</div></div>`;
};
